import React from "react";
import { Divider, Typography } from "@material-ui/core";

export default ({ withDivider, title, children, classes }) => (
  <div className={classes?.root}>
    {withDivider && <div className="pb-24"><Divider /></div>}
    {title && <Typography className="mx-32 mb-16 font-bold" color="textSecondary">{title}</Typography>}
    <div className="items-container">
      {children}
    </div>
  </div>
);
